export const selectIdleHumidity = (state) => state.humidifierState.idleHumidity;
export const selectIsIdleHumidityEnabled = (state) => state.humidifierState.isIdleHumidityEnabled;
export const selectHumidifierDoorStatus = (state) => state.humidifierState.humidifierDoorStatus;
export const selectHumidifierRuntime = (state) => state.humidifierState.humidifierRuntime;
export const selectIsHumidifierInstalled = (state) => state.humidifierState.isHumidifierInstalled;
export const selectHumidifierError = (state) => state.humidifierState.humidifierError;
export const selectIsWaterLevelLow = (state) => state.humidifierState.isWaterLevelLow;
export const selectIsHumidifierConnected = (state) => state.humidifierState.isHumidifierConnected;
